// Auto-import SASS generated CSS
import './index.css';

export type {TabsProps} from './Tabs';
export type {TabModel} from './_Tab';
export {default as default} from './Tabs';
